"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loggers = exports.default = void 0;
var _diagnostics = _interopRequireDefault(require("diagnostics"));
//
// Keep track of the entire logging stack.
//
const loggers = exports.loggers = {};

/**
 * Setup diagnostic logger with `util` namespace.
 *
 * @param {String} name Scope of the logger.
 * @returns {Function} diagnostics instance.
 * @api public
 */
function debug(name) {
  const logger = loggers[name] = (0, _diagnostics.default)(`util:${name}`);
  return logger;
}
var _default = exports.default = debug;